import React from 'react';
import styled from 'styled-components';

/* Brand social icons (inherit color via currentColor) */
const IconFacebook = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.44 2.89h-2.34v6.99A10 10 0 0 0 22 12z"/>
  </svg>
);
const IconTwitter = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231zm-1.16 17.52h1.833L7.084 4.126H5.117l11.966 15.644z"/>
  </svg>
);
const IconInstagram = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
  </svg>
);
const IconLinkedIn = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM3 9h4v12H3V9zm6 0h3.8v1.64h.05c.53-1 1.83-2.05 3.77-2.05C20.4 8.59 21 11 21 14.2V21h-4v-6c0-1.43-.03-3.27-2-3.27s-2.3 1.56-2.3 3.17V21H9V9z"/>
  </svg>
);

const FooterEl = styled.footer`
  background: #0a0a0a;
  color: #e0e0e0;
  position: relative;
  overflow: hidden;
`;

const TopGradientBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #ff3366, #ffb400, #00b0ff, #082189);
`;

const GlowTopRight = styled.div`
  position: absolute;
  top: -200px;
  right: -200px;
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(255, 51, 102, 0.1) 0%, rgba(0, 0, 0, 0) 70%);
  border-radius: 50%;
`;

const GlowBottomLeft = styled.div`
  position: absolute;
  bottom: -200px;
  left: -200px;
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(0, 176, 255, 0.1) 0%, rgba(0, 0, 0, 0) 70%);
  border-radius: 50%;
`;

const FooterMain = styled.div`
  padding: 50px 0 40px;

  @media (max-width: 767px) {
    padding: 40px 0 24px;
  }
`;

const BrandCol = styled.div`
  padding-right: 40px;
  margin-bottom: 30px;

  @media (max-width: 767px) {
    padding-right: 0;
  }
`;

const LogoLink = styled.a`
  display: inline-block;
  margin-bottom: 20px;
`;

const BrandText = styled.p`
  font-size: 14px;
  color: #a0a0a0;
  line-height: 1.8;
  margin-bottom: 30px;
`;

const SocialRow = styled.div`
  display: flex;
  gap: 15px;
`;

const SocialLink = styled.a`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  transition: all 0.3s ease;
  text-decoration: none;

  &:hover {
    background: #ff3366;
    transform: translateY(-3px);
  }
`;

const Col = styled.div`
  margin-bottom: 30px;
`;

const ColHeading = styled.h4`
  font-size: 12px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 22px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
`;

const LinkList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const LinkListItem = styled.li`
  margin-bottom: 13px;
`;

const QuickLink = styled.a`
  color: #a0a0a0;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s ease;

  &:hover {
    color: #ff3366;
  }
`;

const LocationRow = styled.div`
  display: flex;
  gap: 12px;
`;

const LocationPin = styled.span`
  font-size: 16px;
  margin-top: 2px;
`;

const LocationText = styled.p`
  color: #a0a0a0;
  font-size: 14px;
  line-height: 1.7;
  margin: 0;
`;

const HelpLabel = styled.span`
  color: #888;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 1px;
  display: block;
  margin-bottom: 6px;
`;

const HelpLink = styled.a`
  color: #fff;
  font-size: 15px;
  font-weight: ${({ $bold }) => ($bold ? 600 : 'normal')};
  text-decoration: none;
  transition: color 0.3s ease;

  &:hover {
    color: #ff3366;
  }
`;

const BottomBar = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  padding: 16px 0;
`;

const Copyright = styled.p`
  color: #888;
  font-size: 14px;
  margin: 0;
`;

const Footer = () => {
  return (
    <FooterEl className="z-index-1">
      {/* Decorative gradient overlay */}
      <TopGradientBar />
      <GlowTopRight />
      <GlowBottomLeft />

      <FooterMain>
        <div className="container container-1230">
          <div className="row">
            <BrandCol className="col-xl-4 col-lg-4 col-md-6">
              <div className="mb-30">
                <LogoLink href="/">
                   <img data-width={110} className="logo-white" src="/assets/img/home-01/hero/hero-video-1.png" alt="logo" />
                </LogoLink>
                <BrandText>
                  Your Home. Your Style. Always #HarKaamChakachak! We bring world-class services directly to your doorstep.
                </BrandText>
                <SocialRow>
                  {[
                    { label: 'Facebook', url: 'https://facebook.com', Icon: IconFacebook },
                    { label: 'Twitter', url: 'https://twitter.com', Icon: IconTwitter },
                    { label: 'Instagram', url: 'https://instagram.com', Icon: IconInstagram },
                    { label: 'LinkedIn', url: 'https://linkedin.com', Icon: IconLinkedIn },
                  ].map(({ label, url, Icon }) => (
                    <SocialLink key={label} href={url} target="_blank" rel="noreferrer" aria-label={label}>
                      <Icon />
                    </SocialLink>
                  ))}
                </SocialRow>
              </div>
            </BrandCol>

            {/* Quick Links Column */}
            <Col className="col-xl-2 col-lg-4 col-md-6">
              <ColHeading>Quick Links</ColHeading>
              <LinkList>
                {[{name: "Deals & Offers", url: "/deals"}, {name: "Search Services", url: "/search"}, {name: "About Us", url: "/about"}, {name: "Reviews", url: "/reviews"}, {name: "Support", url: "/support"}].map(link => (
                  <LinkListItem key={link.name}>
                    <QuickLink href={link.url}>
                      {link.name}
                    </QuickLink>
                  </LinkListItem>
                ))}
              </LinkList>
            </Col>

            <Col className="col-xl-3 col-lg-4 col-md-6">
              <ColHeading>Our Location</ColHeading>
              <LocationRow>
                <LocationPin>📍</LocationPin>
                <LocationText>
                  Gamut Di Lusso, Road No 12,<br />
                  Banjara Hills, Hyderabad,<br />
                  Telangana, 500034
                </LocationText>
              </LocationRow>
            </Col>

            <Col className="col-xl-3 col-lg-4 col-md-6">
              <ColHeading>Need Help?</ColHeading>
              <div className="mb-20">
                <HelpLabel>Call us directly</HelpLabel>
                <HelpLink href="tel:123456789" $bold>
                  08062271234
                </HelpLink>
              </div>
              <div>
                <HelpLabel>Need live support?</HelpLabel>
                <HelpLink href="mailto:info@citycraft.in">
                  info@citycraft.in
                </HelpLink>
              </div>
            </Col>
          </div>
        </div>
      </FooterMain>

      <BottomBar>
        <div className="container container-1430">
          <div className="row align-items-center">
            <div className="col-12 text-center">
              <Copyright>&copy; {new Date().getFullYear()} CITY CRAFT TECHNOLOGIES Pvt Ltd. All Rights Reserved.</Copyright>
            </div>
          </div>
        </div>
      </BottomBar>
    </FooterEl>
  );
};

export default Footer;
